// Port of api/fuel/app/classes/controller/api/monty/tags/family/create.php
import DB from 'offline/db'
import {
	familyToArray,
	invalid,
	persist,
	sessionUserId,
	unauthorised,
	validateFamilyData
} from '../shared'

export default function(params) {
	var userId = sessionUserId(params)
	var data = params.data || {}

	if (!userId) {
		return unauthorised()
	}

	if (!validateFamilyData(data)) {
		return invalid()
	}

	DB.run('INSERT INTO tag_family (user_id, group_id, buddies_id, family_context, family_public, family_style, family_type, family_name, family_fore, family_colour, family_attachments) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)', [
		parseInt(userId, 10) || 0,
		0,
		0,
		parseInt(data.context, 10) || 0,
		parseInt(data.public, 10) || 0,
		parseInt(data.style, 10) || 0,
		parseInt(data.type, 10) || 0,
		String(data.name || '').trim(),
		String(data.fore || ''),
		String(data.colour || ''),
		0
	])

	var id = DB.scalar('SELECT last_insert_rowid()')
	var rows = DB.query('SELECT * FROM tag_family WHERE family_id = ?', [id])
	return persist(familyToArray(rows[0]))
}
